namespace Areas.VendorReview.Edit {
    "use strict";


    let tabItems = Areas.createTabsWithSameAction("Reviewers", "Edit",
        ["ContractLink", "User", "RotatingHistory"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }


}